import validate from "/Users/simon/Documents/equation-internal/app/frontend3/node_modules/nuxt/dist/pages/runtime/validate.js";
import client_45global from "/Users/simon/Documents/equation-internal/app/frontend3/middleware/client.global.ts";
import reset_45breadcrumbs_45global from "/Users/simon/Documents/equation-internal/app/frontend3/middleware/reset-breadcrumbs.global.ts";
import super_45admin_45global from "/Users/simon/Documents/equation-internal/app/frontend3/middleware/super-admin.global.ts";
import manifest_45route_45rule from "/Users/simon/Documents/equation-internal/app/frontend3/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  client_45global,
  reset_45breadcrumbs_45global,
  super_45admin_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}